import * as rules from "./container/AddRule";
import * as autoAssignCarrierComponents from "./container/AutoAssign";
import * as disableCarrierComponents from "./container/DisableCarrier";

const Carriers = disableCarrierComponents.Carriers;
const CarriersRules = autoAssignCarrierComponents.CarriersRules;
const RulesContainer = rules.RulesContainer;

export { Carriers, CarriersRules, RulesContainer };
